import { ComponentChildren } from 'preact';

function FeatureCard({
  icon,
  title,
  children,
}: {
  icon: string;
  title: string;
  children: ComponentChildren;
}) {
  return (
    <div class="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 hover:bg-white/15 transition-colors">
      <h3 class="text-xl font-semibold mb-3 flex items-center gap-3">
        <span class="text-2xl">{icon}</span>
        {title}
      </h3>
      <p class="text-white/90 leading-relaxed">{children}</p>
    </div>
  );
}

export function FormHeader(props: { title: ComponentChildren; subtitle?: ComponentChildren }) {
  return (
    <header class="flex flex-col gap-1 text-center">
      <h1 class="text-3xl font-medium leading-normal text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 to-sky-500">
        {props.title}
      </h1>
      {props.subtitle && <p>{props.subtitle}</p>}
    </header>
  );
}

export function LoginWrapper({ children }: { children?: ComponentChildren }) {
  return (
    <div class="grid md:grid-cols-2 grow min-h-screen">
      <section class="flex flex-col grow items-center justify-center p-10 relative overflow-auto">
        {children}
        <div class="absolute right-0 inset-y-0 w-2 bg-gradient-to-b from-transparent to-transparent via-sky-400"></div>
      </section>
      <section class="bg-gradient-to-br from-indigo-600 to-purple-700 flex flex-col grow justify-center p-10 text-white relative overflow-hidden">
        <div class="max-w-2xl mx-auto">
          <h2 class="text-3xl font-bold mb-8 text-center">What you'll build...</h2>
          <div class="grid gap-6">
            <FeatureCard icon="🎤" title="AI Voice Interview">
              Share your coaching expertise in a natural conversation. Our AI listens, understands,
              and captures your unique approach to help clients transform their lives.
            </FeatureCard>

            <FeatureCard icon="✨" title="Professional Landing Page">
              Get a beautiful coaching website that reflects your voice and expertise.{' '}
              <span class="font-semibold text-yellow-300">No design skills needed</span> - just your
              authentic story and approach.
            </FeatureCard>

            <FeatureCard icon="📅" title="Integrated Calendar">
              Built-in scheduling system lets clients book sessions with you instantly. Simple
              setup, automatic confirmations, and seamless client experience.
            </FeatureCard>

            <FeatureCard icon="🚀" title="Publish & Grow">
              Launch on your custom domain like{' '}
              <span class="font-semibold text-yellow-300">yourname.example.com</span> and start
              attracting clients who need exactly what you offer.
            </FeatureCard>
          </div>
        </div>
      </section>
    </div>
  );
}
